var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "position-fixed w-100 bg-white add-to-basket-sticky py-2",
        { "slide-up": !_vm.isVisible, "slide-up-active": _vm.isVisible },
      ],
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }